import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';

export const Span = styled.span(() =>
  mq({
    display: 'inline-block',
  }),
);
